import { useState } from "react"
import robinWordmark from "~/images/integrations/robin-wordmark"
import { ConnectRobinModal } from "~/screens/modals/ConnectRobinModal"

export const TryRobinButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        onClick={() => setIsModalOpen(true)}
        className="inline-flex items-center justify-center whitespace-nowrap font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-white text-gray90 border border-gray30 hover:bg-gray20 rounded h-10 px-[24px] py-2 gap-2"
      >
        Connect <img {...robinWordmark} alt="Robin" className="h-4 w-auto" />
      </button>
      <ConnectRobinModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  )
}
